// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2uMP1","balanceDisclaimer":"posDashboard_balanceDisclaimer__3CHFw"};